import React from "react";
import { ResponsiveDeviceType } from "../../layouts/ScreenMedia";

import AppTheme from "../../../service/app_config/AppTheme";
import UtilityHelper from "../../../service/utilities/UtilityHelper";

import { ReactComponent as GoogleIcon } from "../../../assets/images/icons/google_ic.svg";
import { ReactComponent as FacebookIcon } from "../../../assets/images/icons/facebook_ic.svg";
import { ReactComponent as EyeOpen } from "../../../assets/images/icons/eye_open.svg";
import { ReactComponent as EyeClose } from "../../../assets/images/icons/eye_close.svg";
import { ReactComponent as Home } from "../../../assets/images/icons/home.svg";
import { ReactComponent as Home2 } from "../../../assets/images/icons/home2.svg";
import { ReactComponent as Chats } from "../../../assets/images/icons/chats.svg";
import { ReactComponent as Chats2 } from "../../../assets/images/icons/chats2.svg";
import { ReactComponent as Notices } from "../../../assets/images/icons/notices.svg";
import { ReactComponent as Notices2 } from "../../../assets/images/icons/notices2.svg";
import { ReactComponent as Settings } from "../../../assets/images/icons/settings.svg";
import { ReactComponent as Settings2 } from "../../../assets/images/icons/settings2.svg";
import { ReactComponent as Search } from "../../../assets/images/icons/search.svg";
//import { ReactComponent as Search2 } from "../../../assets/images/icons/search2.svg";
import { ReactComponent as Switch2 } from "../../../assets/images/icons/switch2.svg";
import { ReactComponent as Plus } from "../../../assets/images/icons/plus.svg";
import { ReactComponent as Arrowback } from "../../../assets/images/icons/arrow_back.svg";
import { ReactComponent as Magnify } from "../../../assets/images/icons/magnify.svg";
import { ReactComponent as More } from "../../../assets/images/icons/more.svg";

import { ReactComponent as DeptChat } from "../../../assets/images/icons/dept_chats.svg";
import { ReactComponent as Team } from "../../../assets/images/icons/team.svg";
import { ReactComponent as Groups } from "../../../assets/images/icons/groups.svg";
import { ReactComponent as FeedBack } from "../../../assets/images/icons/feedback.svg";
import { ReactComponent as Products } from "../../../assets/images/icons/products.svg";
import { ReactComponent as Email } from "../../../assets/images/icons/email.svg";
import { ReactComponent as AppIcon } from "../../../assets/images/icons/app_ic.svg";
import { ReactComponent as Call } from "../../../assets/images/icons/call.svg";
import { ReactComponent as Location } from "../../../assets/images/icons/location.svg";

import { ReactComponent as SocialFacebook } from "../../../assets/images/icons/facebook.svg";
import { ReactComponent as SocialFiverr } from "../../../assets/images/icons/fiverr.svg";
import { ReactComponent as SocialImo } from "../../../assets/images/icons/imo.svg";
import { ReactComponent as SocialInstagram } from "../../../assets/images/icons/instagram.svg";
import { ReactComponent as SocialLinkedin } from "../../../assets/images/icons/linkedin.svg";
import { ReactComponent as SocialPinterest } from "../../../assets/images/icons/pinterest.svg";
import { ReactComponent as SocialReddit } from "../../../assets/images/icons/reddit.svg";
import { ReactComponent as SocialSkype } from "../../../assets/images/icons/skype.svg";
import { ReactComponent as SocialSnapchat } from "../../../assets/images/icons/snapchat.svg";
import { ReactComponent as SocialSpotify } from "../../../assets/images/icons/spotify.svg";
import { ReactComponent as SocialTelegram } from "../../../assets/images/icons/telegram.svg";
import { ReactComponent as SocialTikok } from "../../../assets/images/icons/tiktok.svg";
import { ReactComponent as SocialWechat } from "../../../assets/images/icons/wechat.svg";
import { ReactComponent as SocialTwitter } from "../../../assets/images/icons/twitter.svg";
import { ReactComponent as SocialYoutube } from "../../../assets/images/icons/youtube.svg";

import { ReactComponent as Globe } from "../../../assets/images/icons/globe.svg";
import { ReactComponent as Logout3 } from "../../../assets/images/icons/logout3.svg";
import { ReactComponent as Close } from "../../../assets/images/icons/close.svg";
import { ReactComponent as Download } from "../../../assets/images/icons/download.svg";

import { ReactComponent as ChangeBranch } from "../../../assets/images/icons/change_branch.svg";
import { ReactComponent as Language } from "../../../assets/images/icons/language.svg";
import { ReactComponent as MobileUpdates } from "../../../assets/images/icons/mobile_updates.svg";
import { ReactComponent as Privacy } from "../../../assets/images/icons/privacy.svg";
import { ReactComponent as Terms } from "../../../assets/images/icons/terms.svg";
import { ReactComponent as Disclaimer } from "../../../assets/images/icons/disclaimer.svg";
import { ReactComponent as Agreement } from "../../../assets/images/icons/agreement.svg";
import { ReactComponent as Edit } from "../../../assets/images/icons/edit.svg";
import { ReactComponent as Languages } from "../../../assets/images/icons/languages.svg";
import { ReactComponent as SelectCheck } from "../../../assets/images/icons/select.svg";
import { ReactComponent as EditFollow } from "../../../assets/images/icons/edit_follow.svg";
import { ReactComponent as ArrowDown } from "../../../assets/images/icons/arrow_down.svg";
import { ReactComponent as ArrowRight } from "../../../assets/images/icons/arrow_right.svg";
import { ReactComponent as Filter } from "../../../assets/images/icons/filter.svg";
import { ReactComponent as NoData2 } from "../../../assets/images/icons/no_data_2.svg";
import { ReactComponent as Email2 } from "../../../assets/images/icons/email2.svg";
import { ReactComponent as UploadUser } from "../../../assets/images/icons/user.svg";
import { ReactComponent as Switch } from "../../../assets/images/icons/switch.svg";
import { ReactComponent as Automated } from "../../../assets/images/icons/automated.svg";
import { ReactComponent as Messages } from "../../../assets/images/icons/messages.svg";
import { ReactComponent as Delete2 } from "../../../assets/images/icons/delete2.svg";
import { ReactComponent as Mute } from "../../../assets/images/icons/mute.svg";
import { ReactComponent as PaperPlane } from "../../../assets/images/icons/paper_plane.svg";
import { ReactComponent as Mic } from "../../../assets/images/icons/mic.svg";
import { ReactComponent as Plus2 } from "../../../assets/images/icons/plus2.svg";
import { ReactComponent as Camera } from "../../../assets/images/icons/camera.svg";
import { ReactComponent as Gallery } from "../../../assets/images/icons/gallery.svg";
import { ReactComponent as Document } from "../../../assets/images/icons/document.svg";
import { ReactComponent as ChatLocation } from "../../../assets/images/icons/chat_location.svg";
import { ReactComponent as MenuList } from "../../../assets/images/icons/menu_list.svg";
import { ReactComponent as ChatDeliver } from "../../../assets/images/icons/chat_deliver.svg";
import { ReactComponent as ChatRead } from "../../../assets/images/icons/chat_read.svg";
import { ReactComponent as NoImage } from "../../../assets/images/icons/no_image.svg";
import { ReactComponent as Forward } from "../../../assets/images/icons/forward.svg";
import { ReactComponent as AudioPause } from "../../../assets/images/icons/audio_pause.svg";
import { ReactComponent as AudioPlay } from "../../../assets/images/icons/audio_play.svg";
import { ReactComponent as Cancel } from "../../../assets/images/icons/cancel.svg";
import { ReactComponent as CallPhone } from "../../../assets/images/icons/call_icon.svg";
import { ReactComponent as Form } from "../../../assets/images/icons/form_icon.svg";
import { ReactComponent as RecordingMic } from "../../../assets/images/icons/recording_icon.svg";
import { ReactComponent as Rewind } from "../../../assets/images/icons/rewind.svg";
import { ReactComponent as Duplicate } from "../../../assets/images/icons/duplicate.svg";
import { ReactComponent as Trash } from "../../../assets/images/icons/trash.svg";
import { ReactComponent as Forward2 } from "../../../assets/images/icons/chat_forward.svg";

// IMAGE
import PNGCamera from "../../../assets/images/icons/camera.png";
import PNGMic from "../../../assets/images/icons/mic.png";
import PNGVideo from "../../../assets/images/icons/video.png";
import PNGDoc from "../../../assets/images/icons/doc2.png";
import PNGLoc from "../../../assets/images/icons/loc2.png";
import PNGBan from "../../../assets/images/icons/ban.png";
import PNGLocation2 from "../../../assets/images/icons/location2.png";
import PNGCurrentLoc from "../../../assets/images/icons/current_loc.png";
import PNGLocReply from "../../../assets/images/icons/loc_reply_type.png";

type CircleFilledIcon = {
  name: string;
  size?: number;
  isSvg?: boolean | true;
  bgColor?: string | "";
  color?: string | "";
  className?: string;
  wrapBgColor?: string | "";
  handleClick?: () => void;
};

export const IconImageAsset: React.FC<CircleFilledIcon> = ({
  name,
  size = 24,
  color = "",
}) => {
  let iconName = "";
  if (name === "camera") {
    iconName = PNGCamera;
  } else if (name === "mic") {
    iconName = PNGMic;
  } else if (name === "video") {
    iconName = PNGVideo;
  } else if (["doc", "doc2"].includes(name)) {
    iconName = PNGDoc;
  } else if (["location", "loc"].includes(name)) {
    iconName = PNGLoc;
  } else if (name === "ban") {
    iconName = PNGBan;
  } else if (["location2", "loc2"].includes(name)) {
    iconName = PNGLocation2;
  } else if (name === "current_loc") {
    iconName = PNGCurrentLoc;
  } else if (name === "loc_reply_type") {
    iconName = PNGLocReply;
  }

  return (
    <img
      src={iconName}
      alt="Logo"
      width={size}
      className="flex-shrink"
      style={{
        filter: UtilityHelper.isNotEmpty(color)
          ? UtilityHelper.hexToFilter(color)
          : undefined,
      }}
    />
  );
};

export const IconNormal: React.FC<CircleFilledIcon> = ({
  name,
  size = 24,
  isSvg = true,
  bgColor = "",
 color = "color-theme-font",
  handleClick,
}) => {
  AppTheme.applyStyleConst();
  let style: any = {
    fill: AppTheme.subLabel,
    width: `${size}px`,
    height: `${size}px`,
  };
  if (UtilityHelper.isNotEmpty(color)) {
    style = { ...style, color: color };
  }
  const classes = `${bgColor}`;
  return handleClick !== undefined ? (
    <div role="button" onClick={handleClick}>
      {getIcon(name, isSvg, classes, style)}
    </div>
  ) : (
    getIcon(name, isSvg, classes, style)
  );
};

export const IconCircleFilledIcon: React.FC<CircleFilledIcon> = ({
  name,
  size,
  isSvg = true,
  className = "",
  bgColor = "bgcolor-primary",
  wrapBgColor = "",
  color = "color-theme-font",
  handleClick,
}) => {
  AppTheme.applyStyleConst();
  const type: number = ResponsiveDeviceType();

  const iconSize =
    size !== undefined ? size : type === 1 ? 40 : type === 2 ? 45 : 50;

  let style: any = {
    fill: AppTheme.themeFont,
    width: `${iconSize}px`,
    height: `${iconSize}px`,
  };

  if (UtilityHelper.isNotEmpty(wrapBgColor)) {
    style = {
      ...style,
      width: `${iconSize - 15}px`,
      height: `${iconSize - 15}px`,
    };
  }

  if (UtilityHelper.isNotEmpty(color)) {
    style = { ...style, color: color };
  }
  const classes = `${bgColor} ${className} rounded-circle`;

  const wrapCircle = (): JSX.Element => {
    let icon: JSX.Element =
      handleClick !== undefined ? (
        <div role="button" onClick={handleClick}>
          {getIcon(name, isSvg, classes, style)}
        </div>
      ) : (
        getIcon(name, isSvg, classes, style)
      );

    return icon;
  };

  return UtilityHelper.isNotEmpty(wrapBgColor) ? (
    <div
      className={`rounded-circle ${wrapBgColor} d-center`}
      style={{ height: iconSize, width: iconSize }}
    >
      {wrapCircle()}
    </div>
  ) : (
    wrapCircle()
  );
};

const getIcon = (
  name: string = "",
  isSvg: boolean = true,
  classes: string = "",
  style: any = {}
): JSX.Element => {
  let icon: JSX.Element = <></>;

  if (isSvg) {
    classes = `${classes} flex-shrink`;
    if (name === "google_ic") {
      icon = <GoogleIcon style={style} className={classes} />;
    } else if (name === "facebook_ic") {
      icon = <FacebookIcon style={style} className={classes} />;
    } else if (name === "eye_open") {
      icon = <EyeOpen style={style} className={classes} />;
    } else if (name === "eye_close") {
      icon = <EyeClose style={style} className={classes} />;
    } else if (name === "search" || name === "search2") {
      icon = <Search style={style} className={classes} />;
    } else if (name === "swicth2") {
      icon = <Switch2 style={style} className={classes} />;
    } else if (name === "notices") {
      icon = <Notices style={style} className={classes} />;
    } else if (name === "notices2") {
      icon = <Notices2 style={style} className={classes} />;
    } else if (name === "home") {
      icon = <Home style={style} className={classes} />;
    } else if (name === "home2") {
      icon = <Home2 style={style} className={classes} />;
    } else if (name === "chats") {
      icon = <Chats style={style} className={classes} />;
    } else if (name === "chats2") {
      icon = <Chats2 style={style} className={classes} />;
    } else if (name === "settings") {
      icon = <Settings style={style} className={classes} />;
    } else if (name === "settings2") {
      icon = <Settings2 style={style} className={classes} />;
    } else if (name === "facebook") {
      icon = <SocialFacebook style={style} className={classes} />;
    } else if (name === "fiverr") {
      icon = <SocialFiverr style={style} className={classes} />;
    } else if (name === "imo") {
      icon = <SocialImo style={style} className={classes} />;
    } else if (name === "instagram") {
      icon = <SocialInstagram style={style} className={classes} />;
    } else if (name === "linkedin") {
      icon = <SocialLinkedin style={style} className={classes} />;
    } else if (name === "pinterest") {
      icon = <SocialPinterest style={style} className={classes} />;
    } else if (name === "reddit") {
      icon = <SocialReddit style={style} className={classes} />;
    } else if (name === "skype") {
      icon = <SocialSkype style={style} className={classes} />;
    } else if (name === "snapchat") {
      icon = <SocialSnapchat style={style} className={classes} />;
    } else if (name === "spotify") {
      icon = <SocialSpotify style={style} className={classes} />;
    } else if (name === "telegram") {
      icon = <SocialTelegram style={style} className={classes} />;
    } else if (name === "tiktok") {
      icon = <SocialTikok style={style} className={classes} />;
    } else if (name === "wechat") {
      icon = <SocialWechat style={style} className={classes} />;
    } else if (name === "twitter") {
      icon = <SocialTwitter style={style} className={classes} />;
    } else if (name === "youtube") {
      icon = <SocialYoutube style={style} className={classes} />;
    } else if (name === "plus") {
      icon = <Plus style={style} className={classes} />;
    } else if (name === "dept_chats") {
      icon = <DeptChat style={style} className={classes} />;
    } else if (name === "team") {
      icon = <Team style={style} className={classes} />;
    } else if (name === "groups") {
      icon = <Groups style={style} className={classes} />;
    } else if (name === "feedback") {
      icon = <FeedBack style={style} className={classes} />;
    } else if (name === "products") {
      icon = <Products style={style} className={classes} />;
    } else if (name === "email") {
      icon = <Email style={style} className={classes} />;
    } else if (name === "app_ic") {
      icon = <AppIcon style={style} className={classes} />;
    } else if (name === "call") {
      icon = <Call style={style} className={classes} />;
    } else if (name === "location") {
      icon = <Location style={style} className={classes} />;
    } else if (name === "arrow_back") {
      icon = <Arrowback style={style} className={classes} />;
    } else if (name === "magnify") {
      icon = <Magnify style={style} className={classes} />;
    } else if (name === "more") {
      icon = <More style={style} className={classes} />;
    } else if (name === "logout3") {
      icon = <Logout3 style={style} className={classes} />;
    } else if (name === "globe") {
      icon = <Globe style={style} className={classes} />;
    } else if (name === "close") {
      icon = <Close style={style} className={classes} />;
    } else if (name === "download") {
      icon = <Download style={style} className={classes} />;
    } else if (name === "change_branch") {
      icon = <ChangeBranch style={style} className={classes} />;
    } else if (name === "language") {
      icon = <Language style={style} className={classes} />;
    } else if (name === "mobile_updates") {
      icon = <MobileUpdates style={style} className={classes} />;
    } else if (name === "privacy") {
      icon = <Privacy style={style} className={classes} />;
    } else if (name === "terms") {
      icon = <Terms style={style} className={classes} />;
    } else if (name === "disclaimer") {
      icon = <Disclaimer style={style} className={classes} />;
    } else if (name === "agreement") {
      icon = <Agreement style={style} className={classes} />;
    } else if (name === "edit") {
      icon = <Edit style={style} className={classes} />;
    } else if (name === "languages") {
      icon = <Languages style={style} className={classes} />;
    } else if (["select", "check"].includes(name)) {
      icon = <SelectCheck style={style} className={classes} />;
    } else if (name === "edit_follow") {
      icon = <EditFollow style={style} className={classes} />;
    } else if (name === "arrow_down") {
      icon = <ArrowDown style={style} className={classes} />;
    } else if (name === "arrow_right") {
      icon = <ArrowRight style={style} className={classes} />;
    } else if (name === "filter") {
      icon = <Filter style={style} className={classes} />;
    } else if (name === "no_data_2") {
      icon = <NoData2 style={style} className={classes} />;
    } else if (name === "email2") {
      icon = <Email2 style={style} className={classes} />;
    } else if (name === "upload-user") {
      icon = <UploadUser style={style} className={classes} />;
    } else if (name === "switch") {
      icon = <Switch style={style} className={classes} />;
    } else if (name === "automated") {
      icon = <Automated style={style} className={classes} />;
    } else if (name === "messages") {
      icon = <Messages style={style} className={classes} />;
    } else if (name === "delete2") {
      icon = <Delete2 style={style} className={classes} />;
    } else if (name === "mute") {
      icon = <Mute style={style} className={classes} />;
    } else if (name === "paper_plane") {
      icon = <PaperPlane style={style} className={classes} />;
    } else if (name === "mic") {
      icon = <Mic style={style} className={classes} />;
    } else if (name === "plus2") {
      icon = <Plus2 style={style} className={classes} />;
    } else if (name === "camera") {
      icon = <Camera style={style} className={classes} />;
    } else if (name === "gallery") {
      icon = <Gallery style={style} className={classes} />;
    } else if (name === "document") {
      icon = <Document style={style} className={classes} />;
    } else if (name === "chat_location") {
      icon = <ChatLocation style={style} className={classes} />;
    } else if (name === "menu_list") {
      icon = <MenuList style={style} className={classes} />;
    } else if (name === "chat_deliver") {
      icon = <ChatDeliver style={style} className={classes} />;
    } else if (name === "chat_read") {
      icon = <ChatRead style={style} className={classes} />;
    } else if (name === "no_image") {
      icon = <NoImage style={style} className={classes} />;
    } else if (name === "forward") {
      icon = <Forward style={style} className={classes} />;
    } else if (name === "audio_play") {
      icon = <AudioPlay style={style} className={classes} />;
    } else if (name === "audio_pause") {
      icon = <AudioPause style={style} className={classes} />;
    } else if (name === "cancel") {
      icon = <Cancel style={style} className={classes} />;
    } else if (name === "call_icon") {
      icon = <CallPhone style={style} className={classes} />;
    } else if (name === "form_icon") {
      icon = <Form style={style} className={classes} />;
    } else if (name === "recording_icon") {
      icon = <RecordingMic style={style} className={classes} />;
    } else if (["reply", "rewind"].includes(name)) {
      icon = <Rewind style={style} className={classes} />;
    } else if (name === "duplicate") {
      icon = <Duplicate style={style} className={classes} />;
    } else if (name === "trash") {
      icon = <Trash style={style} className={classes} />;
    } else if (name === "forward2") {
      icon = <Forward2 style={style} className={classes} />;
    }
  }

  return icon;
};
